webpackJsonp([16],{

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_MorphSVGPlugin__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var fat = this.el.querySelector("#obese-belly");
      var bellyButton = this.el.querySelector("#obese-belly-button");
      var obeseLeft = this.el.querySelector("#obese-hand-left");
      var obeseRight = this.el.querySelector("#obese-hand-right");
      var shirt = this.el.querySelector("#obese-shirt");

      TweenMax.set(fat, { transformOrigin: "center" });
      TweenMax.set(obeseLeft, { transformOrigin: "11, 37" });
      TweenMax.set(obeseRight, { transformOrigin: "135, 56" });

      this.animation = new TimelineMax();

      this.animation.fromTo(fat, 2, {
        scaleX: 1.1
      }, {
        scaleY: 1.1,
        repeat: -1,
        yoyo: true,
        ease: Elastic.easeOut.config(1.75, 0.2)
      }, 0);

      this.animation.fromTo(bellyButton, 2, {
        y: -2
      }, {
        y: 2,
        repeat: -1,
        yoyo: true,
        ease: Elastic.easeOut.config(1.75, 0.2)
      }, 0);

      this.animation.fromTo(obeseLeft, 2, {
        rotation: -20
      }, {
        rotation: 10,
        ease: Elastic.easeOut.config(1.2, 0.2),
        repeat: -1,
        yoyo: true
      }, 0);

      this.animation.fromTo(obeseRight, 2, {
        rotation: 375
      }, {
        rotation: 355,
        ease: Elastic.easeOut.config(1.2, 0.2),
        repeat: -1,
        yoyo: true
      }, 0);

      this.animation.from(shirt, 2, {
        morphSVG: "M391.8,363.2c0,0,11.5,16.6,13.7,22.2c2.5,6.5,5,26,5,26s-42.8-20.1-108.5-20.1 c-65.7,0-104.3,20-104.3,20s1.9-18.7,3.8-24.4c2-5.9,11.9-23,11.9-23l-43.9-26.4l30-23.6l3.9-2.8c8.9-6.3,19.5-9.7,30.3-9.7h137 c6.2,0,12.3,1.1,18.1,3.2c5.7,2.1,11.1,5.2,15.9,9.2l30,23.6L391.8,363.2z",

        repeat: -1,
        ease: Elastic.easeOut.config(1.2, 0.2),
        yoyo: true
      }, 0);

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "2 120.9 600 600" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clippath",
          { id: "obese-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M602 420.9c0 165.7-134.3 300-300 300S2 586.6 2 420.9s134.3-300 300-300 300 134.3 300 300" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#obese-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M602 420.9c0 165.7-134.3 300-300 300S2 586.6 2 420.9s134.3-300 300-300 300 134.3 300 300",
            fill: "#DD2C00"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M416.4 641.7l-1.6 6.2-7.7 5c-4.8 3.2-10.8 4-16.3 2.4l-29.4-8.6c-2-.6-3.5-2.2-4-4.2l-1.1-4.3c-.8-3.1-.4-6.5 1.1-9.3l1.5-3c1.2-2.4 1.3-5.3.2-7.8l-9.4-21c-3.4-8.5-4.2-17.9-2.3-26.9l1.8-8.2-9-13.2c-2.6-3.9-5.4-9.7-6.7-14.2l-14.9-30.4 67.4-11.8 4.9 35.8c.3 1.9.3 3.7.1 5.6l-1.8 20.4 1.1 2.9c1.2 3.1 1.2 6.5.2 9.7l-1 2.8-.7 13.4c-.2 4.1-.9 8.2-2.2 12.1l-3.7 11.4c-1.7 5.3-1.4 11.1.9 16.2l2.4 5.3c1.4 3.3 4.6 5.5 8.1 5.7l17.5 1.3c3.2.3 5.5 3.5 4.6 6.7zM183.2 641.7l1.6 6.2 7.7 5c4.8 3.2 10.8 4 16.3 2.4l29.4-8.6c2-.6 3.5-2.2 4-4.2l1.1-4.3c.8-3.1.4-6.5-1.1-9.3l-1.5-3c-1.2-2.4-1.3-5.3-.2-7.8l9.4-21c3.4-8.5 4.2-17.9 2.3-26.9l-1.8-8.2 9-13.2c2.6-3.9 4.6-8.1 6-12.6l15.7-31.9-67.4-11.8-4.9 35.8c-.3 1.9-.3 3.7-.1 5.6l1.8 20.4-1.1 2.9c-1.2 3.1-1.2 6.5-.2 9.7l1 2.8.7 13.4c.2 4.1.9 8.2 2.2 12.1l3.7 11.4c1.7 5.3 1.4 11.1-.9 16.2l-2.4 5.3c-1.4 3.3-4.6 5.5-8.1 5.7l-17.5 1.3c-3.3.2-5.6 3.4-4.7 6.6z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M388.5 495.3l-73.2 14.5-2.3-9.9c-1.1-4.5-5.1-7.7-9.7-7.7h-7.1c-4.6 0-8.7 3.2-9.7 7.7l-2.2 9.8-73.2-14.5s-.9-34.2 0-43.5c.6-6.1 5.9-18.3 5.9-18.3l166.9-3.9s7 22.8 7.2 28.5c.4 9.3-2.6 37.3-2.6 37.3z",
            fill: "#212121"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "obese-belly",
            d: "M393.7 408.4c0 42.8-43.3 64.1-93.5 64.1s-88.4-21.3-88.4-64.1 40.7-77.5 90.9-77.5 91 34.7 91 77.5z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "obese-belly-button",
            d: "M310.2 417c0 1.4-4.5.4-9.6.4s-8.9 1-8.9-.4 4.1-3.6 9.3-3.6c5.1.1 9.2 2.2 9.2 3.6z",
            fill: "#6D4C41"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M200.7 316.2l-27.2 24.2c-4.3 3.9-7.7 8.7-9.7 14.2l-5.7 15.6c-2.6 7-2.9 14.7-.8 21.9l1 3.7c2.2 9.9 2.5 11.8 8.6 11.8l2.1.3c10.6 1.6 21.2-3.2 26.8-12.3l15.7-25 19.3-37.7-30.1-16.7zM403.3 316.2l27.2 24.2c4.3 3.9 7.7 8.7 9.7 14.2l5.7 15.6c2.6 7 2.9 14.7.8 21.9l-1 3.7c-2.2 14.9-6.7 13.9-13.1 13.9h-6.7c-6.1 0-11.8-3.2-14.9-8.4l-18.5-30.7-19.3-37.7 30.1-16.7z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "obese-shirt",
            d: "M391.8 363.2s11.5 16.6 13.7 22.2c2.5 6.5 5 26 5 26l-108.5-.1H197.7s1.9-18.7 3.8-24.4c2-5.9 11.9-23 11.9-23l-43.9-26.4 30-23.6 3.9-2.8c8.9-6.3 19.5-9.7 30.3-9.7h137c6.2 0 12.3 1.1 18.1 3.2 5.7 2.1 11.1 5.2 15.9 9.2l30 23.6-42.9 25.8z",
            fill: "#ff5025"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "obese-hand-right",
            d: "M445.1 397.4l-2.6 8.2c-1.5 4.1-4 4.1-7.9 4.1h-15.1c-8.1 0-16.1-2.1-23.1-6.1l-51.8-29.4-17.1 1.1c-3.2.2-6.5-.3-9.5-1.3l-14-5c-1.4-.5-7.2-3.6-7.2-5.1v-7.6c0-1.1.5-2.1 1.4-2.8l7.6-6.6c.9-.7 3-1.2 5-1.3l9.4 3.2 3.4-1.8c2.5-1.3 5.5-1.7 8.3-.9l13.8 3.6c1.5.4 2.9 1.1 4.2 2l12.6 9.7 48.3 9.5 24 16.6 10.3 9.9z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "obese-hand-left",
            d: "M312 379.8l-1.4 7.5c-.3 1.5-6.5 3.5-8 3.7l-14.7 2.4c-3.2.5-6.4.4-9.6-.4l-16.6-4.2-56.3 19.6c-7.7 2.7-15.9 3.3-23.9 1.8l-14.8-2.7c-3.8-.7-6.3-1.1-7-5.4l-1.1-8.5 12.2-8 26.6-12 49.2-.6 14.2-7.2c1.4-.7 2.9-1.1 4.5-1.2l14.2-1c2.9-.2 5.7.7 8 2.4l3 2.3 9.8-1.5c1.2-.2 2.4.3 3.2 1.2l7.8 8.9c.6.8.9 1.9.7 2.9z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M355.8 301.5l-5.9 8.4c-8.1 11.6-21.4 18.4-35.5 18.4H292c-13.3 0-25.9-6.1-34.1-16.6l-8-10.2s1.4-.1 3.7-.3c6.9-.5 13.1-4.4 16.5-10.4l5.4-9.5h57.8l3.5 7.8c3.1 7 9.8 11.6 17.4 12.2 1 .1 1.6.2 1.6.2z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M352.9 246c0 27.3-2.1 49.5-50.6 49.5-46 0-50.6-22.1-50.6-49.5s26.3-62.9 54.2-62.9 47 35.5 47 62.9z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M349.7 238.3l5.5-3.6c1.7-1.1 3.9-1.1 5.6-.1.9.5 1.2 1.6.9 2.6l-3.4 9.5c-.5 1.4-.9 2.9-1.3 4.4l-1.4 6.2c-.5 2.1-2.8 3.1-4.7 2l-4.8-4.1 3.6-16.9zM254.2 238.3l-5.5-3.6c-1.7-1.1-3.9-1.1-5.6-.1-.9.5-1.2 1.6-.9 2.6l3.4 9.5c.5 1.4.9 2.9 1.3 4.4l1.4 6.2c.5 2.1 2.8 3.1 4.7 2l4.8-4.1-3.6-16.9z",
            fill: "#FFCCBC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M313.3 226.5l21.6 4.5-1.5-4.5-20.1-6.1zM291.4 226.5l-21.6 4.5 1.5-4.5 20.1-6.1z",
            fill: "#3E2723"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M350.5 239.1l-1.3 2.8s7.4-12.3-18.7-19.7c-12.7-3.6-28.5-23.1-28.5-23.1s-16.8 15.8-27.4 19.7c-26 9.6-19.7 23.2-19.7 28.1l-4.6-13c-.4-1.1-.6-2.2-.7-3.3l-1-9.5c-.4-3.5-.2-7.1.5-10.5 2.5-12.7 9.8-23.3 19.8-28.4l4.7-2.4c5.8-3 12.2-3.9 18.5-2.7l2.7.5 10.7-2.2c10.2-2.1 19.7 2.6 29.3 7.5 5.5 2.8 9.6 6.9 12.7 11.4 8.4 12.5 9.5 30.5 3 44.8z",
            fill: "#6D4C41"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M310.2 241.8l4.1-3.7c2.4-2.1 5.5-3.3 8.8-3.3 4.2 0 8.2 2 10.7 5.4l1.1 1.6-5.2-2.1c-2.3-.9-4.7-1.4-7.1-1.4-2.4 0-4.8.5-7 1.4l-5.4 2.1zM294.5 241.8l-4.1-3.7c-2.4-2.1-5.5-3.3-8.8-3.3-4.2 0-8.2 2-10.7 5.4l-1.1 1.6 5.2-2.1c2.3-.9 4.7-1.4 7.1-1.4 2.4 0 4.8.5 7 1.4l5.4 2.1z",
            fill: "#212121"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M282.2 270.5h43.9l-6.5 6.2c-4 3.8-9.4 5.9-14.9 5.9h-1.3c-5.7 0-11.1-2.2-15.2-6.2l-6-5.9z",
            fill: "#FFF"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M301.4 254.5l-3.6 2.6c-.4.3-.8.7-1.1 1.1-1.3 2.3 0 5.2 2.6 5.6l3.8.6c.4.1.8.1 1.1 0l2.8-.4c2.7-.4 4-3.4 2.6-5.7l-.4-.6c-.2-.3-.5-.6-.8-.9l-2.6-2.1c-1.2-1.1-3-1.2-4.4-.2z",
            fill: "#FFBFAB"
          })
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 16.aec1e4edd12a65bb8b4d.js